import { render, staticRenderFns } from "./ExplorerWarning.vue?vue&type=template&id=c65b9dec&"
import script from "./ExplorerWarning.vue?vue&type=script&lang=js&"
export * from "./ExplorerWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports